import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { useDispatch, useSelector } from "react-redux";
import { useBookingTreeService } from "serviceHooks";
import { AppState } from "store";
import { setBookingTreeItems } from "store/actions/bookingTreeActions";

function useBookingTreeItems() {
  const dispatch = useDispatch();
  const bookingTreeService = useBookingTreeService();
  const bookingTreeItems = useSelector((state: AppState) => state.bookingTree.bookingTreeItems);

  const getBookingTreeItems = async () => {
    if (bookingTreeItems && bookingTreeItems.length > 0) {
      return bookingTreeItems;
    }

    const items = (await bookingTreeService.getBookingTreeItems()).map((item) => ({
      ...item,
      description: item.name
        ?.toLowerCase()
        .concat(item.path ? item.path.join(" / ") : "")
        .toLowerCase(),
    }));

    // Remove duplicates since API returns two items with account 6370
    const filteredItems = items.filter(
      (item, index, self) => index === self.findIndex((t) => t.account === item.account)
    );

    dispatch(setBookingTreeItems(filteredItems));
    return filteredItems;
  };

  const searchBookingTreeItems = async (searchValue?: string) => {
    let bookingTreeItems = await getBookingTreeItems();

    if (searchValue) {
      const formattedSearchValue = searchValue.toLowerCase().trim();
      bookingTreeItems = await bookingTreeItems
        .filter((items) => items.description?.includes(formattedSearchValue))
        .sort(
          (a, b) =>
            (a.description?.indexOf(formattedSearchValue) ?? 0) - (b.description?.indexOf(formattedSearchValue) ?? 0)
        );
    }

    return bookingTreeItems;
  };

  const searchBookingTreeItemsAutoComplete = async (searchValue?: string): Promise<AutocompleteListItem[]> => {
    return bookingTreeService.convertToAutoCompleteItems(await searchBookingTreeItems(searchValue));
  };

  const searchBookingTreeItemsSelectionItems = async (searchValue?: string): Promise<AutocompleteListItem[]> => {
    return bookingTreeService.convertToSelectionItems(await searchBookingTreeItems(searchValue));
  };

  return { getBookingTreeItems, searchBookingTreeItemsAutoComplete, searchBookingTreeItemsSelectionItems };
}

export default useBookingTreeItems;
